import setDisplayName from 'recompose/setDisplayName';
import wrapDisplayName from 'recompose/wrapDisplayName';
var setHOCDisplayName = function setHOCDisplayName(name) {
  return function (BaseComponent) {
    return setDisplayName(wrapDisplayName(BaseComponent, name))(BaseComponent);
  };
};
export default setHOCDisplayName;